"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 3.7a.7.7 0 0 1 .7-.7h12.6a.7.7 0 0 1 .7.7v7.875h-1.4V7.55H4.4v8.05H11V17H3.7a.7.7 0 0 1-.7-.7zm1.4 2.45h11.2V4.4H4.4z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.374 9.7a.7.7 0 0 1 .495.205l1.826 1.826a.7.7 0 0 1 0 .99l-4.929 4.929a.7.7 0 0 1-.412.2l-2.072.245a.7.7 0 0 1-.777-.777l.245-2.072a.7.7 0 0 1 .2-.412l4.929-4.929a.7.7 0 0 1 .495-.205m-4.262 5.952L12 16.6l.948-.112 4.262-4.262-.836-.836zm.642-6.165a.7.7 0 0 1 .036.99l-2.824 3.036a.7.7 0 0 1-1.025 0l-1.73-1.861a.7.7 0 1 1 1.024-.953l1.218 1.31 2.312-2.486a.7.7 0 0 1 .989-.036",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CalendarWithPencilIcon20.js.map